var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center my-2",attrs:{"border-variant":"primary","bg-variant":_vm.getBgVariant(),"text-variant":"white"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"figure-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('p',{staticClass:"card-text figure-value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }